import rootReducer from 'src/old/reducers';
import { api, superApi, zeusApi, commonApi, authMiddleware, zeusSuperApi, loaderMiddleware, zeusApiV1 } from './api';

import { type Action, configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { type ThunkDispatch } from 'redux-thunk';

const loadState = () => {
  const stateString = localStorage.getItem('state');
  if (!stateString) {
    return undefined;
  }

  const storedState = JSON.parse(stateString);
  if (!storedState?.user) {
    return undefined;
  }
  return {
    session: storedState
  };
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: true
    })
      .concat(api.middleware)
      .concat(commonApi.middleware)
      .concat(superApi.middleware)
      .concat(zeusApiV1.middleware)
      .concat(zeusApi.middleware)
      .concat(zeusSuperApi.middleware)
      .concat(authMiddleware)
      .concat(loaderMiddleware);
  },
  preloadedState: loadState(),
  devTools: process.env.NODE_ENV !== 'production'
});

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = ThunkDispatch<AppState, undefined, Action<string>>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
